export default __webpack_public_path__ + "static/media/446.6459808e.png";